import { app_perm_set_hdr_RowClass, app_perm_set_line_RowClass } from "blg-akaun-ts-lib";

export class PermissionSetModel {
    app_perm_set_hdr: app_perm_set_hdr_RowClass = new app_perm_set_hdr_RowClass();
    permSetLines: PermSetLine[] = [];
}

export class PermSetLine {
    app_perm_set_line: app_perm_set_line_RowClass = new app_perm_set_line_RowClass();
    default_target_view_name: string;
    default_target_hdr_name: string;
}
